export default __webpack_public_path__ + "static/media/5.6145d7eb.webp";